export const faqs = [
  {
    question: "O que torna o Frozen Yogurt diferente dos produtos tradicionais?",
    answer:
      "Nossa linha é desenvolvida com iogurte liofilizado de alta qualidade, preservando o sabor autêntico do iogurte, a leve acidez equilibrada e uma textura extremamente cremosa. O resultado é uma sobremesa premium, refrescante e ideal para operações gastronômicas que buscam diferenciação.",
  },
  {
    question: "Como é o modo de preparo da linha Frozen Yogurt?",
    answer:
      "Adicionar 1kg de Dry Mix em 4 litros de leite integral, bater por aproximadamente 5 minutos no liquidificador e colocar diretamente na máquina soft.",
  },
  {
    question: "Quais são os benefícios do iogurte liofilizado?",
    answer:
      "O iogurte liofilizado proporciona sabor mais puro e concentrado, maior estabilidade da receita, textura cremosa e excelente harmonização com frutas, mel, matcha, lichia e outros ingredientes premium.",
  },
  {
    question: "Qual a validade da linha Frozen Yogurt?",
    answer:
      "Até 2 anos quando armazenado em local seco, fresco e protegido da umidade.",
  },
  {
    question: "Qual o prazo de entrega?",
    answer:
      "O prazo médio é de até 3 dias úteis após a confirmação do pagamento.",
  },
  {
    question: "Qual o pedido mínimo?",
    answer:
      "Para a linha Frozen Yogurt, o pedido mínimo é de 10kg. Para a linha de sorvetes, o pedido mínimo é de 5 caixas de 10 litros.",
  },
  {
    question: "Qual a validade da linha de sorvetes?",
    answer:
      "Até 12 meses quando armazenado congelado a -15°C ou temperatura inferior.",
  },
];